import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const HomeIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_homeillustration_svg_a)"
      d="m143.407 132.046 5.231-.969-1.453-.775-5.037.872z"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_homeillustration_svg_b)"
      d="m82.479 142.314 23.538-4.65-39.812-19.761-23.538 4.65z"
      opacity={0.6}
    />
    <path fill="#C39000" d="M106.017 74.604v63.06l-39.812-19.761v-63.06z" />
    <path fill="#FCCE09" d="m141.18 38.28-35.163 36.324v63.06l70.325-12.496v-63.35z" />
    <path fill="#99460E" d="m105.436 76.057 35.743-39.134L99.333 16 63.59 55.425z" />
    <path fill="#823C0D" d="M105.436 76.057v5.134L63.59 60.56v-5.134z" />
    <path fill="#BC5F20" d="M105.436 76.057v5.909l35.743-39.425 37.488 26.348V62.98l-37.488-26.057z" />
    <path fill="#BC9361" d="M148.638 81.966v49.111l22.957-4.068V77.801z" />
    <path fill="#996A0D" d="m148.638 81.966 22.957-4.165-1.549-.872-22.861 4.262z" />
    <path fill="#634509" d="M148.638 81.966v49.111l-1.453-.678V81.191z" />
    <path fill="#E2E2E2" d="m170.336 106.279-3.971.775v-1.065l3.971-.775z" />
    <path fill="#F7F6E4" d="M114.541 89.328v23.442l23.926-4.263V84.969z" />
    <path fill="#E4F4F4" d="m138.467 87.197-19.76 24.894 9.88-1.743 9.88-10.462z" />
    <path fill="#C6E5E4" d="m138.467 99.886-9.88 10.462 9.88-1.841z" />
    <path fill="#BC9361" d="M113.67 88.36v25.669l1.646-.291v-25.67zM137.595 84v25.767l1.744-.291V83.71z" />
    <path fill="#BC9361" d="M113.67 112.188v1.841l25.669-4.553v-1.937zM113.67 88.36v1.84l25.669-4.553V83.71z" />
    <path fill="#634509" d="M113.669 88.36v25.669l-1.065-.485v-25.67z" />
    <path fill="#996A0D" d="m113.67 88.36 25.669-4.65-1.162-.582-25.573 4.747z" />
    <defs>
      <linearGradient
        id="dhl__illustrations_homeillustration_svg_a"
        x1={144.729}
        x2={145.075}
        y1={131.448}
        y2={130.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_homeillustration_svg_b"
        x1={67.855}
        x2={74.172}
        y1={133.95}
        y2={120.44}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
